"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getActiveWin = void 0;
/**
 * Get metadata about the active window (title, id, bounds, owner, etc).
 *
 * @param options - configure whether the function should obtain screen recording permission
 * @returns — The active window metadata.
 */
const getActiveWin = (options) => __awaiter(void 0, void 0, void 0, function* () { return yield window.todesktop.activeWin.getActiveWin(options); });
exports.getActiveWin = getActiveWin;
